// extracted by mini-css-extract-plugin
module.exports = {"informativeLabel":"styles_informativeLabel__18iW9"};